import StepPaymentInfo from './stepPaymentInfo';

export default StepPaymentInfo;
